import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-alert-bien',
  templateUrl: './modal-alert-bien.component.html',
  styleUrls: ['./modal-alert-bien.component.scss'],
})
export class ModalAlertBienComponent implements OnInit {
  @Input() message: any = '';
  @Input() status = 'success';
  @Output() saveOrUpdate = new EventEmitter<any>();

  @ViewChild('contentAlertBien') contentAlertBien: any;

  constructor(private modalService: NgbModal, private router: Router) {}

  openVertically(content: any) {
    this.modalService.open(content, { size: 'xl' });
  }
  home() {
    this.modalService.dismissAll();
    void this.router.navigateByUrl('/');
  }
  ngOnInit() {
    setTimeout(() => {
      this.openVertically(this.contentAlertBien);
      this.saveOrUpdate.emit();
    }, 0);
  }
}
